<script setup lang="ts">
    import type { HTMLType } from './Html.vue';

    defineProps<{
        components: HTMLType[];
    }>();
</script>
<template>
    <template v-for="comp in components">
        <template v-if="comp.type === 'text'">
            {{ comp.children }}
        </template>
        <template v-else-if="comp.type === 'br'">
            <br />
        </template>
        <component
            v-else
            :is="comp.type"
            v-bind="comp.props">
            <renderer-html-tree
                v-if="Array.isArray(comp.children)"
                :components="comp.children" />
        </component>
    </template>
</template>
